module.exports = __webpack_public_path__ + "img/neue-apotheke-eingang-aerztehaus.739725b1.jpg";